import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ESkeletonType, INSAutoCompleteOption } from '@norfolk-southern/accessns-components';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { NSCommonConstants } from '@ruby/configs/common.constants';
import { IUserInfo } from '@ruby/modules/account/models/contact.interface';

@Component({
  selector: 'ng-ut-origin-batch-weigh',
  templateUrl: './ut-origin-batch-weigh.component.html',
  styleUrls: ['./ut-origin-batch-weigh.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UTOriginBatchWeighComponent implements OnChanges, OnDestroy {
  @Input() userInfo?: IUserInfo;
  @Input() origins!: Array<INSAutoCompleteOption>;
  @Input() originsLoading!: boolean;
  @Input() loading!: boolean;
  @Input() source?: string;
  @Input() coalDensity?: number;
  @Output() searchOrigins = new EventEmitter<string>();
  @Output() searchCoalDensity = new EventEmitter<string>();
  @Output() submitReport = new EventEmitter<{ coalDensity: number; originId: number; recipient: string }>();
  form = new UntypedFormGroup({
    coalDensity: new UntypedFormControl('', Validators.required),
    origin: new UntypedFormControl('', Validators.required),
    recipient: new UntypedFormControl('', [Validators.required, Validators.pattern(NSCommonConstants.multipleEmailPattern)])
  });
  skeleton: ESkeletonType = ESkeletonType.PIPE;
  private subscriptionNotifier = new Subject<void>();

  constructor() {
    this.setupForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.userInfo?.currentValue) {
      this.form.controls.recipient.setValue(changes.userInfo.currentValue.contact?.email);
    } else if (changes.coalDensity?.currentValue) {
      this.form.controls.coalDensity.setValue(this.coalDensity);
    }
  }

  ngOnDestroy(): void {
    this.subscriptionNotifier.next();
    this.subscriptionNotifier.complete();
  }

  /**
   * Submit
   *
   * @summary emits submit report event
   * @returns void
   */
  submit(): void {
    this.submitReport.emit({
      coalDensity: this.form.controls.coalDensity.value,
      originId: this.form.controls.origin.value.key,
      recipient: this.form.controls.recipient.value
    });
  }

  private setupForm() {
    this.form.controls.origin.valueChanges.pipe(
      takeUntil(this.subscriptionNotifier),
      debounceTime(250),
      distinctUntilChanged()
    ).subscribe((value: string | INSAutoCompleteOption) => {
      if (typeof value === 'string' && value.length > 3) {
        this.searchOrigins.emit(value);
      } else if (typeof value !== 'string' && value.key) {
        this.searchCoalDensity.emit(value.key);
      }
    });
  }
}
